import { StorageAutarkyDto } from '../api/dto'
import { StorageAutarky } from '../models/storage.models'

export function fromAutarkyDtoToModel(dto: StorageAutarkyDto): StorageAutarky {
  return { ...dto }
}
